import React from 'react';
import BlankCard from '~components/atoms/BlankCard';

import * as Styles from './inventorySummary.module.scss';

type Props = {
  total: number;
  used: number;
  balance: number;
};

const BranchInventorySummary = ({ total, used, balance }: Props) => {
    return (
        <div className={Styles.container}>
            <BlankCard>
                <div className={Styles['card-content']}>
                    <p>TOTAL (g)</p>
                    <h3>{total}</h3>
                </div>
            </BlankCard>

            <BlankCard>
                <div className={Styles['card-content']}>
                    <p>TOTAL USED (g)</p>
                    <h3>{used}</h3>
                </div>
            </BlankCard>

            <BlankCard>
                <div className={Styles['card-content']}>
                    <p>TOTAL BALANCE (g)</p>
                    <h3>{balance}</h3>
                </div>
            </BlankCard>
        </div>
    );
};

export default BranchInventorySummary;
